// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"clear-formatting"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M22.2739 11.5454L14.0312 3.30273L5.78861 11.5454L14.0312 19.788L22.2739 11.5454Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M5.78831 11.5454L1.66699 15.6667L7.16209 21.1618L18.9997 21.1618M5.78831 11.5454L14.031 3.30273L22.2736 11.5454L14.031 19.788L5.78831 11.5454ZM14.3561 19.4648L12.6696 21.1635L13.2251 20.6039","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-clear-formatting')
export default class ClearFormattingIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'clear-formatting',
    }
  }
}
